export const formAssignmentFields = {
  CONFIRM: 'confirm',
};
